const $swatchesInput = $('.js-color-swatches input');

$swatchesInput.on('click', function () {
  const $this = $(this);
  const colorName = $this.data('name');
  const liParent = $this.parents('li');

  liParent.addClass('is-selected').siblings().removeClass('is-selected');
  $('.js-color-text').text(colorName);
});

$swatchesInput.prop('checked', false);
